import { ICoreContext, IGeneric, IAny } from '@msdyn365-commerce/core';
import { AttributeValue } from '@msdyn365-commerce/retail-proxy';
// import { useState, useEffect } from 'react';
// import { generateImageUrl } from '@msdyn365-commerce-modules/retail-actions';
// import { Composition } from '../themes/suedwolle/views/buybox.view';
import { IProductAttributeRecordIds, findProductAttributes } from './helpers';

// Custom hook for PDP attributes implementation
export const useAttributeState = (context: ICoreContext<IGeneric<IAny>>, productAttributesData?: AttributeValue[]) => {
    const {
        colourCardAttributeRecordId,
        treatmentAttributeRecordId,
        spinningTechAttributeRecordId,
        countAttributeRecordId,
        twistAttributeRecordId,
        turnAttributeRecordId,
        guageAttributeRecordId,
        compositionAttributeRecordId,
        micronAttributeRecordId,
        careLabelAttributeRecordId,
        certificatesAttributeRecordId,
        collectionAttributeRecordId,
        segmentAttributeRecordId,
        waxedAttributeRecordId,
        bobbinAttributeRecordId
    } = context.app.config;

    const attributeRecordIds: IProductAttributeRecordIds = {
        segmentAttributeRecordId,
        collectionAttributeRecordId,
        colourCardAttributeRecordId,
        treatmentAttributeRecordId,
        spinningTechAttributeRecordId,
        countAttributeRecordId,
        twistAttributeRecordId,
        turnAttributeRecordId,
        guageAttributeRecordId,
        compositionAttributeRecordId,
        micronAttributeRecordId,
        certificatesAttributeRecordId,
        careLabelAttributeRecordId,
        waxedAttributeRecordId,
        bobbinAttributeRecordId
    };

    const {
        segmentAttribute,
        collectionAttribute,
        colourCardAttribute,
        treatmentAttribute,
        spinningTechAttribute,
        countAttribute,
        twistAttribute,
        turnAttribute,
        guageAttribute,
        compositionAttribute,
        micronAttribute,
        certificatesAttribute,
        careLabelAttribute,
        waxedAttribute,
        bobbianAttribute
    } = findProductAttributes(attributeRecordIds, productAttributesData);

    return {
        segmentAttribute,
        collectionAttribute,
        colourCardAttribute,
        spinningTechAttribute,
        treatmentAttribute,
        countAttribute,
        twistAttribute,
        turnAttribute,
        micronAttribute,
        waxedAttribute,
        bobbianAttribute,
        guageAttribute,
        compositionAttribute,
        certificatesAttribute,
        careLabelAttribute
    };
};
